export {createHideableComponent, useIsHidden} from '../../../src/collections/Hidden';
